import { render, staticRenderFns } from "./SamBanner.vue?vue&type=template&id=46b465a5&scoped=true&"
import script from "./SamBanner.vue?vue&type=script&lang=js&"
export * from "./SamBanner.vue?vue&type=script&lang=js&"
import style0 from "./SamBanner.vue?vue&type=style&index=0&id=46b465a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b465a5",
  null
  
)

export default component.exports